// Public deployment configuration is loaded synchronously before the app bundle.
// REACT_APP_* build values remain a compatibility fallback for local development.
function read(name, buildValue, fallback) {
    const runtime = typeof window !== "undefined" && window.__INTELOG_CONFIG__;
    if (runtime && Object.prototype.hasOwnProperty.call(runtime, name)) {
        return runtime[name];
    }
    return buildValue !== undefined && buildValue !== "" ? buildValue : fallback;
}
module.exports = { read };
